module.exports = __webpack_public_path__ + "static/img/storage01.2b6ed97e.png";